module.exports = __webpack_public_path__ + "img/groceryscape.cb6bcfab.png";